import { render, staticRenderFns } from "./TableStatusPrepayment.vue?vue&type=template&id=24664f46&"
import script from "./TableStatusPrepayment.vue?vue&type=script&lang=ts&"
export * from "./TableStatusPrepayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24664f46')) {
      api.createRecord('24664f46', component.options)
    } else {
      api.reload('24664f46', component.options)
    }
    module.hot.accept("./TableStatusPrepayment.vue?vue&type=template&id=24664f46&", function () {
      api.rerender('24664f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-payables/invoices-prepayment-debit-memo/TableStatusPrepayment.vue"
export default component.exports